import useValidation, { ValidationRule } from 'SharedDir/common/composables/useValidation';
import { DefinedProps } from 'SharedDir/declarations/vue';
import { computed, ComputedRef, toValue } from 'vue';

export default <Params, ETC = {}>(
  props: DefinedProps<{ params: Params; required: boolean; skipValidation: boolean } & ETC>,
  { customRules }: Partial<{ customRules: ValidationRule[] | ComputedRef<ValidationRule[]> }> = {}
) => {
  const params = computed<Params>(() => props.params);
  const { NotEmpty } = useValidation();
  const baseValidationRules = computed(() => (props.required ? [NotEmpty()] : []));
  const validationRules = computed(() => {
    if (props.skipValidation) {
      return [];
    }
    return baseValidationRules.value.concat(toValue(customRules) ?? []);
  });

  return {
    params,
    baseValidationRules,
    validationRules,
  };
};
